import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Injector,
  LOCALE_ID,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {
  GetIdMissionFormStatusResponse,
  GetIdMissionRegistrationResponse,
  GetIdMissionTokenResponse,
} from '@core/dto/start-now-app.dto';
import { Locale } from '@core/enums/locale';
import { AppInitService } from '@core/services/app-init.service';
import { LoggerService } from '@core/services/logger.service';
import { StartNowAppService } from '@core/services/start-now-app.service';
import { AppState } from '@core/store';
import { selectSeguridataFormId, selectStartNowAppData } from '@core/store/start-now-app';
import {
  SeguridataStep,
  StartNowAppData,
} from '@core/store/start-now-app/start-now-app-state-models';
import {
  fetchSeguridataFormId,
  resetSeguridataFormIdFetched,
  stepProcessing,
} from '@core/store/start-now-app/start-now-app.actions';
import { Store } from '@ngrx/store';
import { PaymentHandlerBase } from '@payment/payment-handler/payment-handler-base.model';
import { PaymentHandlerFactory } from '@payment/payment-handler/payment-handler-factory';
import { SafeResourceUrlPipe } from '@shared/pipes/safe-url.pipe';
import { isMexEnv, isUsaEnv } from '@shared/utils/environment-utils';
import {
  StartNowAppStepMX,
  StartNowAppStepUS,
} from 'app/modules/start-now-app/enums/start-now-app-step.enum';
import { StatusCodes } from 'http-status-codes';
import { Observable, of } from 'rxjs';
import { catchError, filter, skip, take } from 'rxjs/operators';
import { SnaConsultantSubmitComponent } from '../../sna-consultant-submit/sna-consultant-submit.component';
import { StartNowStepBaseComponent } from '../../start-now-app-step-base/start-now-step-base.component';

@Component({
  selector: 'app-seguridata-agreement-step',
  templateUrl: './seguridata-agreement-step.component.html',
  styleUrls: ['./seguridata-agreement-step.component.scss'],
})
export class SeguridataAgreementStepComponent
  extends StartNowStepBaseComponent
  implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked
{
  readonly StatusCodes = StatusCodes;
  @Output() navigateToStep: EventEmitter<number> = new EventEmitter<number>();
  readonly isUsaEnv = isUsaEnv;
  readonly isMexEnv = isMexEnv;
  StartNowAppStep = isMexEnv ? StartNowAppStepMX : StartNowAppStepUS;
  idMissionTokenResponse: GetIdMissionTokenResponse | null | undefined;
  idMissionRegistrationResponse: GetIdMissionRegistrationResponse | null | undefined;
  idMissionFormStatusResponse: GetIdMissionFormStatusResponse | null | undefined;
  isIframeInitialized: boolean = false;
  startNowAppData: StartNowAppData;
  productId: string;
  sanitizedUrl: SafeResourceUrl;
  paymentHandler: PaymentHandlerBase;
  windowHeight: number = window.innerHeight;
  windowWidth: number = window.innerWidth;
  seguridataFormId: number;
  seguridataFormGroup: FormGroup;
  seguridataStep$: Observable<SeguridataStep>;
  isSubmitted: boolean = false;
  isError: boolean = false;
  hasNavigated: boolean = false;
  // eslint-disable-next-line max-len
  errorMessage: string = $localize`Please agree to the Consultant agreement terms above to continue.`;

  @ViewChild('snaConsultantSubmit')
  private snaConsultantSubmitComponent: SnaConsultantSubmitComponent;

  @ViewChild('iframe_idmission')
  private iframeRef!: ElementRef<HTMLIFrameElement>;

  constructor(
    private store$: Store<AppState>,
    private fb: FormBuilder,
    private safeResourceUrlPipe: SafeResourceUrlPipe,
    private domSanitizer: DomSanitizer,
    private startNowAppService: StartNowAppService,
    private paymentHandlerFactory: PaymentHandlerFactory,
    private appInitService: AppInitService,
    private elementRef: ElementRef,
    private logger: LoggerService,
    private cdRef: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: Locale,
    injector: Injector,
  ) {
    super(injector, 'SNA Step - 7 Seguridata Agreement');
    this.sanitizedUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
      `${appInitService.getIdMissionBaseUrl()}apps/invokeApps`,
    );

    this.productId = this.appInitService.getIdMissionProductId();
  }

  get getIframeHeight(): string {
    return `${this.windowHeight - 100}px`;
  }

  get getIframeWidth(): string {
    return `${this.windowWidth - 100}px`;
  }

  get getHost(): string {
    return `https://${window.location.host}/${this.localeId}`;
  }

  ngAfterViewChecked() {
    if (!this.isIframeInitialized && this.idMissionTokenResponse) {
      this.onSeguridataFormSubmit();
      this.isIframeInitialized = true;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.store$.dispatch(stepProcessing({ stepProcessing: false }));
    }, 500);
  }

  ngOnInit(): void {
    this.requestStartNowAppData();
    this.seguridataFormGroup = this.createFormGroup();
    this.initializeSeguridataFormIfFormIdNotExists();
    //this.listenSeguridataFormIdFetch();
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.windowHeight = window.innerHeight;
    this.windowWidth = window.innerWidth;
  }

  onSeguridataFormSubmit(): void {
    const form = this.elementRef.nativeElement.querySelector('form');
    form.submit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  /**
   * If the user hits the next button we have to check if the form id is set. If it is set the we can
   * navigate to the next step. If it is not set we have to reload the seguridata form
   */
  submitStep(): void {
    this.isSubmitted = true;
    if (this.seguridataFormId) {
      this.goToNextStep.emit();
    } else {
      this.listenSeguridataFormIdFetch();
      this.store$
        .select(selectSeguridataFormId)
        .pipe(skip(1), take(1))
        .subscribe((seguridataFormId) => {
          if (seguridataFormId != null) {
            this.seguridataFormId = seguridataFormId;
            if (this.seguridataFormId && !this.hasNavigated) {
              this.hasNavigated = true;
              this.goToNextStep.emit();
            }
          }
        });

      this.store$.dispatch(fetchSeguridataFormId({ tokenId: this.idMissionTokenResponse.tokenId }));
    }
  }

  resetSeguridataForm(): void {
    this.store$.dispatch(resetSeguridataFormIdFetched());
  }

  protected createFormGroup(): FormGroup {
    return this.fb.group({});
  }

  private requestStartNowAppData() {
    this.subscriptions.add(
      this.store$
        .select(selectStartNowAppData)
        .pipe(
          filter((startNowAppData) => !!startNowAppData),
          take(1),
        )
        .subscribe((startNowAppData) => {
          this.startNowAppData = startNowAppData;
        }),
    );
  }

  /**
   * Initialize the seguridata form if the seguridataFormId is not set.
   * It will get a new token to initialize the form and get one if there is no seguridataFormId.
   */
  private initializeSeguridataFormIfFormIdNotExists(): void {
    this.subscriptions.add(
      this.store$
        .select(selectSeguridataFormId)
        .pipe(take(1))
        .subscribe((seguridataFormId) => {
          this.seguridataFormId = seguridataFormId;
          if (!seguridataFormId) {
            this.startNowAppService
              .idMissionTokenGet$Json(
                this.startNowAppData.contactInfo.email,
                this.startNowAppData.contactInfo.cellPhoneNumber,
                this.startNowAppData.contactInfo.homeNumber,
                this.startNowAppData.selectedConsultant.beeNumber,
                this.startNowAppData.selectedConsultant.displayName,
              )
              .subscribe((res) => {
                this.idMissionTokenResponse = res;
                console.log('Get token response: ', this.idMissionTokenResponse);
                // force refresh the view to update the iframe
                this.cdRef.detectChanges();
              });
          }
        }),
    );
  }

  private disableErrorMsg() {
    setTimeout(() => {
      this.isError = false;
    }, 15000);
  }

  /**
   * Listens to the fetch of the seguridataFormId and as the user hits the submit and the fetch is done we will
   * emit goToNextStep. If the seguridataFormId is not set, it will not do anything.
   */

  private listenSeguridataFormIdFetch() {
    this.subscriptions.add(
      this.store$
        .select(selectSeguridataFormId)
        .pipe(
          catchError(() => of(null)),
          take(1),
        )
        .subscribe((seguridataFormId) => {
          if (seguridataFormId != null) {
            this.seguridataFormId = seguridataFormId;
            this.isError = false;
          } else {
            this.isError = true;
            this.disableErrorMsg();
          }
        }),
    );
  }
}
